module.exports = __webpack_public_path__ + "static/media/serene.274edd6e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/question-images/serene.jpg
// module id = 145
// module chunks = 0